<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Ingressos</h1>
        <paragrafo>
          Veja abaixo algumas opções de configurações de campanha e tipos de
          variações de ingressos</paragrafo
        ><paragrafo><negrito>Ingresso com DATA e TEXTO</negrito></paragrafo>
        <imagem :src="image_7" />
        <paragrafo
          ><negrito>Ingresso com DATA, HORA e TEXTO</negrito></paragrafo
        >
        <imagem :src="image_8" />
        <paragrafo><negrito>Ingresso LOTE</negrito></paragrafo>
        <paragrafo
          >No primeiro campo selecione a opção de variação do tipo TEXTO e
          preencha os campos "Valores da opção", conforme abaixo. Após isso,
          clique na engrenagem (seta vermelha), adicione o valor desse lote e a
          quantidade de itens. Faça isso em todos e clique em Pronto (Após
          clicar na opção Pronto - deve ser clicada apenas uma única vez - edite
          essa variação de lote apenas no ícone do lápis disponível logo
          abaixo).</paragrafo
        >
        <imagem :src="image_9" />
        <paragrafo
          >Veja abaixo como fica a estrutura dos lotes. Ative a opção de
          <negrito>Gerenciamento por lote</negrito> e clique no ícone do lápis
          para inicar a configuração que permite que os lotes funcionem
          automaticamente.</paragrafo
        >
        <imagem :src="image_10" />
        <paragrafo
          ><negrito>Como fazer a ordenação do lote?</negrito></paragrafo
        >
        <paragrafo
          >Edite o Lote 2 e marque o lote antecessor. Esta ordem deve ser
          aplicada nos outros lotes.</paragrafo
        >
        <paragrafo
          >Na imagem abaixo foi clicado no lápis de edição do Lote 2 e
          selecionado o Lote 1, ou seja, o antecessor. Com essa configuração,
          quando o Lote 1 finalizar o estoque, o Lote 2 ficará
          disponível.</paragrafo
        >
        <imagem :src="image_11" />
        <ul class="mt-5">
          <li>Editar o Lote 2 e marcar o Lote 1;</li>
          <li>Editar o Lote 3 e marcar o Lote 2;</li>
          <li>Editar o Lote 4 e marcar o Lote 3...</li>
        </ul>
        <paragrafo
          ><li>
            O lote pode ser configurado de duas formas: uma automática que foi o
            caso descrito acima e uma forma manual que, basicamente, consiste na
            criação de 1 produto para cada lote, ou seja, deve ser criado 1
            produto para o lote 1, 1 produto para o lote 2 e assim por diante.
            Deve-se deixar apenas o produto lote 1 disponível e os outros
            inativos. No momento que desejar alterar o lote, basta inativar o
            produto lote 1 e ativar o produto lote 2.
          </li></paragrafo
        >
        <paragrafo
          ><negrito>Ingresso SEM VARIAÇÃO</negrito>
          <paragrafo
            >Não é necessário marcar a opção de variações "este produto tem
            várias opções como cores e tamanhos diferentes". A visualização do
            produto será básica.</paragrafo
          >
        </paragrafo>
        <paragrafo
          ><negrito>Produto VOUCHER</negrito>
          <paragrafo
            >A configuração é padrão, porém é preciso apenas informar, nas
            Regras de Acesso, quantos “dias para expirar” e o “limite de uso”
            deste voucher.</paragrafo
          >
        </paragrafo>
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "Ingressos",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem.vue"),
    negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_7: "/documentacao/produtos/produtos7.png",
      image_8: "/documentacao/produtos/produtos8.png",
      image_9: "/documentacao/produtos/produtos9.png",
      image_10: "/documentacao/produtos/produtos10.png",
      image_11: "/documentacao/produtos/produtos11.png",
    };
  },
};
</script>
